import React, { useEffect, useState } from "react";
import { image } from "../../src/common/Theme";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Apiconnection from "../utils/Apiconnection";
import Loader from "../utils/Loader";

function Sidebar({ openSidebarToggle, OpenSidebar }) {
  const [sidebarMenu, setSidebarMenu] = useState([]);
  const [loading, setloading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleNavigation = () => {
    if (openSidebarToggle) {
      OpenSidebar();
    }
  };

  useEffect(() => {
    const getSidebar = async () => {
      setloading(true);
      try {
        const response = await Apiconnection.post("module-list");
        console.log("sidebar response", response);
        setloading(false);
        if (response?.data?.status) {
          setSidebarMenu(response?.data?.data);
        }
      } catch (error) {
        setloading(false);
        console.log("error", error);
        if (error.response?.status === 401) {
          navigate("/login");
          localStorage.clear();
        }
      }
    };
    getSidebar();
  }, []);

  console.log("Side bar ", sidebarMenu);

  const renderSubMenu = (menuItem, index) => {
    if (menuItem.parentModuleId === null) {
      const subMenuItems = sidebarMenu.filter(
        (subMenuItem) => subMenuItem.parentModuleId === menuItem.id,
      );
      const isChildActive = subMenuItems.some(
        (subMenuItem) => location.pathname === `/${subMenuItem.moduleSlug}`,
      );

      return (
        <li
          key={index}
          className={`sidebar-list-item ${subMenuItems.length > 0 ? "has-submenu" : ""} ${location.pathname === `/${menuItem.moduleSlug}` || isChildActive ? "active" : ""}`}
        >
          <Link to={`/${menuItem.moduleSlug}`} onClick={handleNavigation}>
            <div className="icon">
              <img src={menuItem.moduleIcon} alt="" />
            </div>
            {menuItem.moduleName}
          </Link>
          {subMenuItems.length > 0 && (
            <ul className="sidebar-submenu">
              {subMenuItems.map((subMenuItem, subIndex) => (
                <li
                  key={subIndex}
                  className={`sidebar-list-item ${location.pathname === `/${subMenuItem.moduleSlug}` ? "active" : ""}`}
                >
                  <Link to={`/${subMenuItem.moduleSlug}`} onClick={handleNavigation}>
                    <div className="icon">
                      <img src={subMenuItem.moduleIcon} alt="" />
                    </div>
                    {subMenuItem.moduleName}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    }
    return null;
  };

  return (
    <>
      <div
        className={`sidebar-backdrop ${openSidebarToggle ? "active" : ""}`}
        onClick={OpenSidebar}
      />
      <aside
        id="sidebar"
        className={openSidebarToggle ? "sidebar-responsive" : ""}
      >
        {loading && <Loader />}
        <div className="sidebar-title">
          <div className="sidebar-brand">
            <img className="logo-img" src={image.logo} alt="Prime Park logo" />
            <div className="sidebar-brand-copy">
              <span>Prime Park</span>
              <small>Admin Console</small>
            </div>
          </div>
          <button type="button" className="icon close_icon" onClick={OpenSidebar} aria-label="Close navigation">
            X
          </button>
        </div>

        <div className="sidebar-scroll-area">
          <div className="sidebar-section-label">Navigation</div>
          <ul className="sidebar-list">
            <li className="sidebar-list-item">
              <NavLink to="/dashboard" onClick={handleNavigation}>
                <div className="icon">
                  <img src={image.dashboard} alt="" />
                </div>
                Dashboard
              </NavLink>
            </li>

            {sidebarMenu.map((menuItem, index) => renderSubMenu(menuItem, index))}
          </ul>
        </div>

        <div className="sidebar-footer">
          <ul className="sidebar-footer-list">
            <li className="sidebar-list-item">
              <NavLink to="/profile" onClick={handleNavigation}>
                <div className="icon">
                  <img src={image.userimage || image.dashboard} alt="" />
                </div>
                Profile
              </NavLink>
            </li>

            <li className="sidebar-list-item">
              <NavLink to="/change-password" onClick={handleNavigation}>
                <div className="icon">
                  <img src={image.lock || image.dashboard} alt="" />
                </div>
                Change Password
              </NavLink>
            </li>

            <li className="sidebar-list-item">
              <button type="button" className="sidebar-link-content logout-button" onClick={handleLogout}>
                <div className="icon">
                  <img src={image.logout} alt="" />
                </div>
                Logout
              </button>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
